import UserRoleCURModule from "@/modules/UserRoleCUR";

function EditUserRolePage() {
    return (
        <UserRoleCURModule typePage="edit" />
    )
}

export default EditUserRolePage;